export class EndpointBuilder {
  constructor() {
    this.version = 1;
    this._path = "";
  }

  static make() {
    return new EndpointBuilder();
  }

  v0() {
    this.version = 0;
    return this;
  }

  v1() {
    this.version = 1;
    return this;
  }

  path(path) {
    this._path = path;
    return this;
  }

  build() {
    const cleanPath = this._path.replace(/^\/+/, "");
    return `/v${this.version}/${cleanPath}`;
  }
}

export const resources = {
  public: {
    order: (sessionToken) =>
      EndpointBuilder.make()
        .v1()
        .path(`public/sessions/${sessionToken}/order`)
        .build(),
    address: (zipcode) =>
      EndpointBuilder.make().v0().path(`public/address/${zipcode}`).build(),
    payment: EndpointBuilder.make().v1().path("public/payments").build(),
    lastEvent: (sessionToken) =>
      EndpointBuilder.make()
        .v1()
        .path(`public/sessions/${sessionToken}/transactions/events/last`)
        .build(),
    wait: (sessionToken) =>
      EndpointBuilder.make()
        .v1()
        .path(`public/sessions/${sessionToken}/transactions/events/wait`)
        .build(),
  },
};
